'use client';

import { useMemo } from 'react';
import { useSearchParams, usePathname } from 'next/navigation';
import dynamic from 'next/dynamic';
import { observer } from 'mobx-react-lite';

import useSearchEvent from 'hooks/useSearchEvent';
import { tabsSearch, urlParamsSearch } from 'constants/search';

import * as styles from './TabsNavigationSearch.css';

import type { TabItem } from './TabsNavigation';
// import SearchTerm from 'components/SearchTerm/SearchTerm';
// import SearchFilter from 'components/SearchFilter/SearchFilter';
const TabsNavigation = dynamic(() => import('./TabsNavigation'));
const SearchTerm = dynamic(() => import('components/SearchTerm/SearchTerm'));
const SearchFilter = dynamic(() => import('components/SearchFilter/SearchFilter'), { ssr: false });

function TabsNavigationSearch({ handleChange, hasFilter = true }: { handleChange?: (item: TabItem) => void; hasFilter?: boolean }) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const searchEventStore = useSearchEvent();
  const searchTerm = searchParams?.get(urlParamsSearch.term) as string;

  const currentPage = useMemo(() => pathname?.split('/')?.[1], [pathname]);

  return (
    <div className={styles.ContainerTabs}>
      {searchTerm && <SearchTerm searchTerm={searchTerm} />}
      <div className={styles.Content}>
        <div className={styles.ContentTabs}>
          <TabsNavigation
            tabsList={[
              {
                label: tabsSearch.event.label,
                tabName: tabsSearch.event.tabName,
                ariaLabel: tabsSearch.event.ariaLabel,
              },
              {
                label: tabsSearch.place.label,
                tabName: tabsSearch.place.tabName,
                ariaLabel: tabsSearch.place.ariaLabel,
              },
              {
                label: tabsSearch.organizer.label,
                tabName: tabsSearch.organizer.tabName,
                ariaLabel: tabsSearch.organizer.ariaLabel,
              },
            ]}
            handleChange={handleChange}
          />
        </div>
        {currentPage === 'eventos' && hasFilter && <SearchFilter fetchData={searchEventStore.fetchData} />}
      </div>
    </div>
  );
}

export default observer(TabsNavigationSearch);
